import { render, staticRenderFns } from "./pressReleaseDetail.vue?vue&type=template&id=3c3b5593&"
import script from "./pressReleaseDetail.vue?vue&type=script&lang=js&"
export * from "./pressReleaseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports